import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c07832"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-modal-root"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-modal-mask" }, null, -1))
const _hoisted_3 = { class: "ant-modal-wrap" }
const _hoisted_4 = { class: "ant-modal" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-modal-close-x" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "img",
    "aria-label": "close",
    class: "anticon anticon-close ant-modal-close-icon"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "",
      "data-icon": "close",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      viewBox: "64 64 896 896",
      focusable: "false"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" })
    ])
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ant-modal-header" }
const _hoisted_8 = { class: "ant-modal-title" }
const _hoisted_9 = { class: "ant-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
            ref: "container",
            w: 'auto',
            h: 'auto',
            x: _ctx.position.x,
            y: _ctx.position.y,
            isResizable: false,
            parentLimitation: true,
            style: {display: 'inline-block'}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "ant-modal-content",
                  style: _normalizeStyle({width: _ctx.modalWidth})
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-label": "Close",
                    class: "ant-modal-close",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseModal && _ctx.handleCloseModal(...args)))
                  }, _hoisted_6),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _renderSlot(_ctx.$slots, "title", {}, () => [
                        _createTextVNode(_toDisplayString(_ctx.title), 1)
                      ], true)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "ant-modal-body",
                    style: _normalizeStyle({height: _ctx.modalHeight})
                  }, [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ], 4),
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                  ])
                ], 4)
              ])
            ]),
            _: 3
          }, 8, ["x", "y"]))
        ])
      ]))
    : _createCommentVNode("", true)
}